<template>
  <form @submit.prevent="submitSearch">
    <div class="search-input">
      <input type="text" :placeholder="$t('dispatch.rsvpSearchPlaceholder')" v-model="searchInput" />
      <a href="javascript:;" v-show="searchInput !== ''" @click="clearSearch">
        <i class="far fa-times-circle fa-lg fa-fw"></i>
      </a>
    </div>
  </form>
</template>

<script>
import ApiDispatchReservation from '@/modules/api/dispatch/reservations'
export default {
  name: 'reservation-search',
  computed: {
    searchInput: {
      get () { return this.$store.state.reservation.reservationSearch },
      set (value) { this.$store.commit('reservation/setReservationSearch', value) }
    }
  },
  methods: {
    submitSearch () {
      let self = this
      self.$store.commit('dispatch/resetRsvpPaging')
      ApiDispatchReservation.getReservations(self)
      ApiDispatchReservation.getLastSync(self)
    },
    clearSearch () {
      let self = this
      self.$store.commit('reservation/resetReservationSearch')
      self.$store.commit('dispatch/resetRsvpPaging')
      ApiDispatchReservation.getReservations(self)
    }
  }
}
</script>

<style lang="scss" scoped>
form{
  display: block;
}
input {
  margin: 0;
  border-radius: 0;
  padding: 0 15px;
  height: 50px;
  line-height: 50px;
  border-top: 0;
  border-bottom: 0;
  border-color: rgba(0,0,0,0.3);
}

.search-input{
  position: relative;

  & a {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    line-height: 50px;
    color: #777;
    width: 50px;
    text-align: center;

    & i { line-height: inherit; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/ReservationSearch.vue